import {inject, Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

import {
  API_ENTITY_INVOICE_DETAILS,
  API_ENTITY_INVOICE_DETAILS_CURRENCY,
  API_ENTITY_INVOICES,
  API_INVOICE_LINES,
  API_INVOICES
} from '../config/urls';
import {UrlService} from '@shared/services/url.service';
import {InvoiceDetailsListDTO} from '@dto/invoices/invoice-details-list-dto.model';
import {InvoiceLinesDTO} from '@dto/invoices/invoice-lines-dto.model';
import {InvoiceDTO} from '@dto/invoices/invoices-dto.model';

@Injectable({
  providedIn: 'root'
})
export class InvoicesService {
  private readonly http = inject(HttpClient);
  private readonly urlService = inject(UrlService);

  public getInvoices(): Observable<InvoiceDTO[]> {
    return this.http.get<InvoiceDTO[]>(API_INVOICES, { observe: 'response' }).pipe(
      map(response => response.body ?? [])
    );
  }

  public getClientInvoices(clientCode: string): Observable<InvoiceDTO[]> {
    const endpointUrl = this.urlService.buildUrl(API_ENTITY_INVOICES, clientCode);
    return this.http.get<InvoiceDTO[]>(endpointUrl, { observe: 'response' }).pipe(
      map(response => response.body ?? [])
    );
  }

  public getInvoiceDetails(clientCode: string): Observable<InvoiceDetailsListDTO> {
    const endpointUrl = this.urlService.buildUrl(API_ENTITY_INVOICE_DETAILS, clientCode);
    return this.http.get<InvoiceDetailsListDTO>(endpointUrl);
  }

  public getInvoiceDetailsByCurrency(clientCode: string, currencyCode: string): Observable<InvoiceDetailsListDTO> {
    const endpointUrl = this.urlService.buildUrl(API_ENTITY_INVOICE_DETAILS_CURRENCY, clientCode, currencyCode);
    return this.http.get<InvoiceDetailsListDTO>(endpointUrl);
  }

  public getInvoiceLines(invoiceCode: string): Observable<InvoiceLinesDTO[]> {
    const endpointUrl = this.urlService.buildUrl(API_INVOICE_LINES, invoiceCode);
    return this.http.get<InvoiceLinesDTO[]>(endpointUrl, { observe: 'response' }).pipe(
      map(response => response.body ?? [])
    );
  }
}
